export default {
  process: (err) => {
    if (err.response?.status === 404) {
      // validate error, do something
      $nuxt.$router.push('/404');
      return false;
    }
  },
};
